/**
 * Terms of Use: scroll to section 10 when visiting with #terms-point-10.
 * Uses id="terms-point-10" if present, else first heading or .rte paragraph whose text starts with "10." (e.g. 10.1 …).
 */
(function () {
  'use strict';

  var ANCHOR = 'terms-point-10';

  function pathOk() {
    var p = window.location.pathname.replace(/\/$/, '');
    return /\/pages\/terms-of-use-agbs$/.test(p);
  }

  function hashOk() {
    return decodeURIComponent((window.location.hash || '').slice(1)) === ANCHOR;
  }

  function headerOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height');
    var n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  }

  /** Matches "10.", "10)", "10 -", etc. at block start (section 10 on Terms page uses <p>10.1 …). */
  function isSection10Start(text) {
    return /^10(?:[\s.)]|[\u2013\-–—])/u.test(text.trim());
  }

  function findTarget() {
    var byId = document.getElementById(ANCHOR);
    if (byId) return byId;

    var nodes = document.querySelectorAll(
      '#MainContent h2, #MainContent h3, #MainContent h4, ' +
        '#MainContent .rte h2, #MainContent .rte h3, #MainContent .rte h4, ' +
        '#MainContent .rte p, main .rte p, ' +
        'main .rte h2, main .rte h3, main .rte h4'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (isSection10Start(nodes[i].textContent)) return nodes[i];
    }
    return null;
  }

  function scrollToAnchor() {
    if (!pathOk() || !hashOk()) return;

    var pad = 12;
    var attempt = 0;

    function run() {
      var el = findTarget();
      if (!el) {
        if (attempt < 5) {
          attempt += 1;
          setTimeout(run, 100);
        }
        return;
      }
      var y = el.getBoundingClientRect().top + window.scrollY - headerOffset() - pad;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    requestAnimationFrame(function () {
      setTimeout(run, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToAnchor);
  } else {
    scrollToAnchor();
  }

  window.addEventListener('hashchange', scrollToAnchor);
})();
